
import React from 'react';
import { Outlet } from 'react-router-dom';
import V2Navigation from './V2Navigation';

const V2Layout = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-juv-soft-blush to-white">
      <V2Navigation />
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default V2Layout;
